<template>
  <AppModal id="verification-code-modal" :close-on-backdrop="true">

    <template #title>
      <h3 class="text-center mb-5">{{$t($getConst.pages.profile.email_verification_code_modal_title) | capitalize}}</h3>
    </template>

    <template #content>
      <div class="mx-auto text-center">

        <b-form-group id="verification_code" :label="$t($getConst.pages.profile.verification_code)"
                      label-for="verification_code-input">
          <b-form-input
            id="verification_code-input"
            v-model.trim="$v.verificationCode.$model"
            :class="{ 'is-invalid': $v.verificationCode.$error || invalidVerificationCode }"
            :placeholder="$t($getConst.pages.profile.enter_verification_code)"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.verificationCode"/>
          <b-form-invalid-feedback v-if="invalidVerificationCode">
            {{$t($getConst.pages.profile.invalid_verification_code)}}.
          </b-form-invalid-feedback>
        </b-form-group>

      </div>

      <p>{{$t($getConst.pages.profile.email_verification_code_modal_content) | capitalize}}</p>
    </template>

    <template #button>
      <AppConfirmButtons
        :submit-text="$t($getConst.pages.button.submit)"
        :is-loading="isLoading"
        @onSubmit="confirmEmailChange"
        @onCancel="closeModal"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  import AppModal from "../../../components/common/modals/AppModal";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import {required} from "vuelidate/lib/validators";
  import {confirmChangeEmail} from "../../../api/userEmail.api";

  export default {
    name: "VerificationCodeModal",
    components: {AppFormFeedback, AppModal, AppConfirmButtons},
    data() {
      return {
        verificationCode: '',
        invalidVerificationCode: false,
        isLoading: false
      }
    },

    validations: {
      verificationCode: {required}
    },

    methods: {
      isFormInvalid() {
        this.$v.$touch();
        return this.$v.$invalid;
      },
      confirmEmailChange() {
        if (this.isFormInvalid()) {
          return;
        }
        this.isLoading = true;
        confirmChangeEmail({verificationCode: this.verificationCode}).then(
          response => {
            if (response.data.status === "invalid_verification_code") {
              this.invalidVerificationCode = true;
            } else {
              this.$emit('verifyCode');
              this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
              this.closeModal();
            }
            this.isLoading = false;
          },
          error => {
            this.handleApiError(error);
            this.closeModal();
            this.isLoading = false;
          }
        )
      },
      closeModal() {
        this.verificationCode = '';
        this.invalidVerificationCode = false;
        this.$v.$reset();
        this.$bvModal.hide("verification-code-modal");
      }
    }
  }
</script>

<style scoped>

</style>
